import Router from 'next/router'
import nookies, { parseCookies, setCookie, destroyCookie } from 'nookies';
import jwt_decode from 'jwt-decode';
import { DateTime } from 'luxon';

export type IUser = {
  email: string;
};

export const checkUser = async (): Promise<any | null> => {
  const cookies = parseCookies();
  let url = '';

  if (Router.pathname) {
    url =  Router.pathname;
  }

  if (!cookies.email) {
    Router.push('/auth/login');
    return null;
  }

  if (cookies.email && !cookies.jwt) {
    if (!url.includes('auth')) {
      Router.push('/auth/validate-email');
    }
  }

  if (cookies.email && cookies.jwt) {
    if (url.includes('auth')) {
      Router.push('/');
    }
    const jwtDecode: any = jwt_decode(cookies.jwt);
    let l: IUser = {
      email: jwtDecode.email || '-',
    };
    return l;
  } else return null;
};

export const getUser = async (): Promise<string | null> => {
  const cookies = parseCookies();
  if (cookies.jwt) {
    let decodedToken: any = jwt_decode(cookies.jwt);
    const now = DateTime.local();
    const expirationDate = DateTime.fromSeconds(decodedToken.exp);
    const diff = expirationDate.diff(now, ['seconds']);
    if (diff.seconds < 30) {
      return null;
    } else {
      return cookies.jwt;
    }
  } else return null;
};